// Production error-log severity + source catalogues.
// Shared by the server (Kysely column types, capture helper, read API) and the
// client (filter dropdowns, severity badges). Mirrors portal-audit.ts.
//
// This module must stay dependency-free (src/common may not import from a
// sub-app directory).

export const ERROR_LOG_SEVERITIES = ['fatal', 'error', 'warning'] as const
export type ErrorLogSeverity = (typeof ERROR_LOG_SEVERITIES)[number]

export const ERROR_LOG_SOURCES = ['http', 'cron', 'process'] as const
export type ErrorLogSource = (typeof ERROR_LOG_SOURCES)[number]
